import { EventDispatcher } from "../events/EventDispatcher";

export abstract class Loader extends EventDispatcher {
    protected static loaders: any = {};

    static prependURL: string = "";
    static cacheTimestamp: string;

    protected _id: string = "";

    abstract getData(): any;

    protected static addLoader(loader: Loader) {
        Loader.loaders[loader._id] = loader;
    }

    protected static removeLoader(loader: Loader) {
        delete Loader.loaders[loader._id];
    }

    static getLoader(id: string): Loader {
        return Loader.loaders[id];
    }

    get id(): string {
        return this._id;
    }
}

